import { Injectable } from "@angular/core";
import { Product, PRODUCTS } from "../models/product";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  // findRandomByBrand(id: string, arg1: number): Product[] {
  //   let copied: Map<number, number> = new Map<number, number>();
  //   let total = this.findByBrand(id).length;
  //   let randomProducts: Product[] = [];
  //   total = arg1 > total ? total : arg1;
  //   let i = 0;
  //   while (i < total) {
  //     let index = Math.floor((Math.random() * this.findByBrand(id).length))
  //     if (!copied.has(index)) {
  //       randomProducts.push(this.findByBrand(id)[index])
  //       copied.set(index, index);
  //       i++;
  //     } else {
  //       //Just for documentation sake not really needed
  //       continue;
  //     }
  //   }
  //   return randomProducts;
  // }

  getProductIndex(product: Product) {
    this.getSelectedIndex(product.id) > 0
      ? this.getSelectedIndex(product.id)
      : 0o1
  }

  private products: Product[] = new Array();

  constructor() {
    //Very important initialization since PRODUCTS is an array of objects that have been cast to type Product
    //Relying on this may cause runtime problems
    PRODUCTS.forEach((element: Product) => {
      let product: Product = new Product();
      product.id = element.id;
      product.name = element.name;
      product.category = element.category;
      product.photo = element.photo;
      product.prices = element.prices;
      product.description = element.description;
      product.description2 = element.description2;
      this.products.push(product);
    });

    // array.sort((a,b) => a.title.rendered.localeCompare(b.title.rendered));
    this.products.sort((a, b) => a.name.localeCompare(b.name));
  }

  find(id: string): Product {
    let i = this.getSelectedIndex(id);
    return i < 0 ? null : this.products[i];
  }

  findAll(): Product[] {
    return this.products;
  }

  slice(array: Product[], start: number, end: number) {
    let result = new Array();
    array.slice(start, end).forEach((value) => result.push(value));
    return result;
  }

  findByCategory(category: string) {
    let products: Product[] = [];
    this.products.forEach((p) => {
      if (p.category.toLowerCase() == category.toLowerCase()) {
        products.push(p);
      }
    });
    return products;
    // if (category.toLowerCase() != null || category.toLowerCase() != undefined) {
    //   return this.products.filter(value => value.category.toLowerCase() === category.toLowerCase())
    // }
  }

  // findByBrand(brand: string) {
  //   let products: Product[] = []
  //   this.products.forEach(p => {
  //     if (p.brandId.toLowerCase() === brand.toLowerCase()) {
  //       products.push(p)
  //     }
  //   })
  //    return products
  // }

  // findAllBrand() {
  //   let products: Product[] = []
  //   this.products.forEach(p => {
  //     if (p.brandId.toLowerCase() != '') {
  //       products.push(p)
  //     }
  //   })
  //    return products
  // }

  findAllCategories() {
    let products: Product[] = [];
    this.products.forEach((p) => {
      if (p.category.toLowerCase() != "") {
        products.push(p);
      }
    });
    return products;
  }

  findRandomAndExcludeOne(maxNo: number, excludedId: string): Product[] {
    let total: number;
    let copied: Map<number, number> = new Map<number, number>();
    let someProducts = [];
    this.products.forEach((p: Product) => {
      someProducts.push(p);
    });
    //Remove product with provided id from products
    for (var j = 0; j < someProducts.length; j++) {
      if (excludedId === someProducts[j].id) {
        someProducts.splice(j, 1);
        break;
      }
    }
    total = someProducts.length;
    let randomProducts: Product[] = [];
    total = maxNo > total ? total : maxNo;
    let i = 0;
    while (i < total) {
      let index = Math.floor(Math.random() * someProducts.length);
      if (!copied.has(index)) {
        randomProducts.push(someProducts[index]);
        copied.set(index, index);
        i++;
      } else {
        //Just for documentation sake not really needed
        continue;
      }
    }
    return randomProducts;
  }

  findRandomAndExcludeMany(
    maxNo: number,
    excludedProducts: Product[]
  ): Product[] {
    let total: number;
    let copied: Map<number, number> = new Map<number, number>();
    let someProducts = [];
    this.findAllCategories().forEach((p: Product) => {
      someProducts.push(p);
    });
    //Remove product with provided ids from products
    excludedProducts.forEach((p) => {
      if (someProducts.includes(p))
        someProducts.splice(someProducts.indexOf(p), 1);
    });
    total = someProducts.length;
    let randomProducts: Product[] = [];
    total = maxNo > total ? total : maxNo;
    let i = 0;
    while (i < total) {
      let index = Math.floor(Math.random() * someProducts.length);
      if (!copied.has(index)) {
        randomProducts.push(someProducts[index]);
        copied.set(index, index);
        i++;
      } else {
        //Just for documentation sake not really needed
        continue;
      }
    }
    return randomProducts;
  }

  findRandom(maxNo: number) {
    let copied: Map<number, number> = new Map<number, number>();
    let total = this.products.length;
    let randomProducts: Product[] = [];
    total = maxNo > total ? total : maxNo;
    let i = 0;
    while (i < total) {
      let index = Math.floor(Math.random() * this.findAllCategories().length);
      if (!copied.has(index)) {
        randomProducts.push(this.findAllCategories()[index]);
        copied.set(index, index);
        i++;
      } else {
        //Just for documentation sake not really needed
        continue;
      }
    }
    return randomProducts;
  }

  search(id: string): Product[] {
    let found: Product[] = [];
    //Assuming all spaces are replaced by +
    let splits = id.split("+");
    for (var i = 0; i < this.products.length; i++) {
      for (var j = 0; j < splits.length; j++) {
        if (
          this.products[i].name
            .toLowerCase()
            .includes(splits[j].toLowerCase()) ||
          this.products[i].id.toLowerCase().includes(splits[j].toLowerCase())
        ) {
          found.push(this.products[i]);
          // break out of loop as soon as we get the first match
          break;
        }
      }
    }
    return found;
  }

  private getSelectedIndex(id: string) {
    for (var i = 0; i < this.products.length; i++) {
      if (this.products[i].id == id) {
        return i;
      }
    }
    return -1;
  }

  findRandomAndExclude(maxNo: number, excludedId: string): Product[] {
    let total: number;
    let copied: Map<number, number> = new Map<number, number>();
    let someProducts = [];
    this.findAllCategories().forEach((p: Product) => {
      someProducts.push(p);
    });
    //Remove product with provided id from products
    for (var j = 0; j < someProducts.length; j++) {
      if (excludedId === someProducts[j].id) {
        someProducts.splice(j, 1);
        break;
      }
    }
    total = someProducts.length;
    let randomProducts: Product[] = [];
    total = maxNo > total ? total : maxNo;
    let i = 0;
    while (i < total) {
      let index = Math.floor(Math.random() * someProducts.length);
      if (!copied.has(index)) {
        randomProducts.push(someProducts[index]);
        copied.set(index, index);
        i++;
      } else {
        //Just for documentation sake not really needed
        continue;
      }
    }
    return randomProducts;
  }

  findRandomByCategory(maxNo: number, category: string) {
    let copied: Map<number, number> = new Map<number, number>();
    let products = this.findByCategory(category);
    let total = products.length;
    let randomProducts: Product[] = [];
    total = maxNo > total ? total : maxNo;
    let i = 0;
    while (i < total) {
      let index = Math.floor(Math.random() * products.length);
      if (!copied.has(index)) {
        randomProducts.push(products[index]);
        copied.set(index, index);
        i++;
      } else {
        //Just for documentation sake not really needed
        continue;
      }
    }
    return randomProducts;
  }
}
